import { render, staticRenderFns } from "./marchInto.vue?vue&type=template&id=4e7e3d70&"
import script from "./marchInto.vue?vue&type=script&lang=js&"
export * from "./marchInto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports